import { render } from "./InquiryDetail.vue?vue&type=template&id=3fe80baf&scoped=true"
import script from "./InquiryDetail.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.vue?vue&type=script&lang=js"

import "./InquiryDetail.vue?vue&type=style&index=0&id=3fe80baf&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe80baf"]])

export default __exports__